var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filter-chip-container",
      class: {
        "chip-container--removable": _vm.removable,
        "chip-container--clearable": _vm.clearable,
      },
      attrs: { "data-filter-field": _vm.dataFilterField },
    },
    [
      _c(
        "CustomPopover",
        {
          ref: "customPopover",
          attrs: {
            icon: _vm.icon,
            label: _vm.getChipLabel(),
            "show-dropdown-arrow": false,
            "button-class": _vm.buttonClass,
            "popover-class": "modern-custom-popover",
            "show-form-footer": true,
            removable: _vm.removable,
            clearable: _vm.clearable,
          },
          on: {
            "popover-change": _vm.onPopoverChange,
            "remove-click": _vm.onRemoveClick,
            "clear-click": _vm.onClearClick,
            clear: _vm.onFooterClear,
            apply: _vm.onFooterApply,
          },
        },
        [
          _c("template", { slot: "content" }, [
            _c("div", { staticClass: "broadcast-composite-container" }, [
              _c("div", { staticClass: "broadcast-composite-field" }, [
                _c("label", { staticClass: "broadcast-composite-label" }, [
                  _vm._v(_vm._s(_vm.$t("chat.filterChip.operator"))),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentOperator,
                        expression: "currentOperator",
                      },
                    ],
                    staticClass: "broadcast-composite-select",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.currentOperator = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.onOperatorChange,
                      ],
                    },
                  },
                  _vm._l(_vm.operatorOptions, function (option) {
                    return _c(
                      "option",
                      { key: option.value, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(option.label) +
                            "\n                        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-composite-field" }, [
                _c("label", { staticClass: "broadcast-composite-label" }, [
                  _vm._v(
                    _vm._s(_vm.filterName || _vm.$t("chat.filterChip.select"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "broadcast-composite-value-wrap" },
                  [
                    _c("MinimalPopoverSelect", {
                      key: "mps-" + String(_vm.effectiveMultiple),
                      ref: "miniPopoverSelect",
                      attrs: {
                        value: _vm.selectBindValue,
                        "value-text": _vm.isEditingPopover ? "" : _vm.valueText,
                        options: _vm.options,
                        multiple: _vm.effectiveMultiple,
                        "filter-name": _vm.$t("auto.select"),
                        "show-icon": true,
                        "enable-search": _vm.enableSearch,
                        "show-dropdown-arrow": true,
                        "button-class":
                          "select-button broadcast-inline-select-trigger" +
                          (_vm.hasValue
                            ? " broadcast-inline-select-trigger--has-value"
                            : ""),
                        "popover-class": "filter-select-popover",
                        "check-icon": "done",
                        "default-icon": _vm.icon,
                        removable: false,
                        clearable: false,
                      },
                      on: {
                        input: _vm.onInput,
                        change: _vm.onValueChange,
                        "search-input": _vm.onSearchInput,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }